import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__classifieds_list_view',
    path: '/l/:listId',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/list.vue' /* webpackChunkName: "pages-classifieds-list.vue" */
        )
      )
  },
  {
    name: '__classified_restore_with_code',
    path: '/classifieds/:classifiedId/restore-with-code/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/restore-with-code.vue' /* webpackChunkName: "pages-classifieds-restore-with-code" */
        )
      )
  },
  {
    name: '__classified_touch_with_code',
    path: '/classifieds/:classifiedId/touch-with-code/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/touch-with-code.vue' /* webpackChunkName: "pages-classifieds-touch-with-code" */
        )
      )
  },
  {
    name: '__compare',
    path: '/classifieds/compare',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/compare.vue' /* webpackChunkName: "pages-classifieds-compare.vue" */
        )
      ),
    meta: {
      hideMobileBottomMenu: true
    }
  }
]
